import React, { Component } from 'react';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import _orderBy from 'lodash/orderBy';
import enableAccordions from 'routes/template/templates/default/contentRules/accordion/handlers';
import CoronaVirusTemplateComponent from './CoronaVirusTemplateComponent';
import { injectIntl } from 'react-intl';

class CoronaVirusTemplate extends Component {
  constructor(props) {
    super(props);

    this.transformDestinationsLinks = this.transformDestinationsLinks.bind(this);
  }

  componentDidMount() {
    enableAccordions();
  }

  transformDestinationsLinks() {
    const { destinations } = this.props;

    if (!destinations) {
      return;
    }

    const _destinations = destinations.map((destination) => ({
      destinationName: destination.name,
      ...destination,
    }));

    return _orderBy(_destinations, 'destinationName', 'asc');
  }

  render() {
    const { intl, content, settings } = this.props;
    const messagesLoaded = !!(intl && !_isEmpty(intl.messages));

    const _destinations = this.transformDestinationsLinks();

    if (!process.browser || !messagesLoaded) {
      return <CoronaVirusTemplateComponent content={content} />;
    }

    const isWhitelabel = settings.company.isWhitelabel;
    const regExp = /{{(wt.*?)}}/g;

    if (isWhitelabel) {
      const matches = content.description.match(regExp);

      if (matches !== null && matches.length > 0) {
        matches.forEach(function (v, i) {
          let id = v.substring(2, v.length - 2);
          let translation = intl.formatMessage({
            id: id,
            defaultMessage: 'Tripx default message',
            description: 'Tripx default message',
          });
          content.description = content.description.replace(v, translation);
        });
      }
    } else {
      content.description = content.description.replace(regExp, '');
    }

    return <CoronaVirusTemplateComponent content={content} destinations={_destinations} />;
  }
}

function mapTld(tld) {
  let _tld = tld;

  if (tld === 'uk' || tld === 'eu') {
    _tld = 'en';
  }

  return _tld;
}

function mapStateToProps(state) {
  const { destinations, settings } = state;
  const { tld } = settings.value;
  const { value } = destinations;
  const _tld = mapTld(tld);

  const _destinations =
    value &&
    value
      .map(({ destinationLanguages }) =>
        destinationLanguages.filter(
          ({ langCode, travelInfoUrls }) => langCode === _tld.toUpperCase() && travelInfoUrls.length > 0
        )
      )
      .flat();

  return {
    settings: state.settings.value,
    destinations: _destinations,
  };
}

export default connect(mapStateToProps)(injectIntl(CoronaVirusTemplate));
